import "./main.css";
import SingaporeLogo from "../../assets/images/General/singaporelogo.png";
import JtcLogo from "../../assets/images/General/jtc-logo3x.png";

function GovernmentHeader(props) {
  const { navbar } = props;
  return (
    <header
      style={{ top: 10, position: "sticky", zIndex: 9999, overflow: "visible" }}
    >
      <div id="header" className="container-fluid">
        <div className="row">
          <div className="component xa-government-bar w-100">
            <div className="component-content">
              <section className="section bg-greyf0f0 section--layout">
                <div className="container-fluid">
                  <div className="row">
                    <div className="container">
                      <div className="government-bar">
                        <a
                          href="https://www.gov.sg"
                          className="government-bar__link"
                        >
                          <span className="government-bar__icon">
                            <img
                              src={SingaporeLogo}
                              alt="SingaporeLogo"
                              width="44"
                              height="54"
                            />
                          </span>
                          <span className="government-bar__title">
                            A Singapore Government Agency Website
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </section>{" "}
            </div>
          </div>

          <div
            className="component xa-container-fluid"
            style={{ backgroundColor: "white" }}
          >
            <div className="component-content">
              <div className="container">
                <div className="row">
                  <div className="component xa-navbar w-100 col-12">
                    <div className="component-content">
                      <div
                        className="navbar-container"
                        style={{ transition: "transform 0s ease 0s" }}
                      >
                        <div className="component xa-government-bar w-100">
                          <div className="component-content">
                            <section className="section bg-greyf0f0 section--layout">
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="container">
                                    <div className="government-bar">
                                      <a
                                        href="https://www.gov.sg"
                                        className="government-bar__link"
                                      >
                                        <span className="government-bar__icon">
                                          <img
                                            src={SingaporeLogo}
                                            alt="SingaporeLogo"
                                            width="44"
                                            height="54"
                                          />
                                        </span>
                                        <span className="government-bar__title">
                                          A Singapore Government Agency Website
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>{" "}
                          </div>
                        </div>
                        {/* <nav className="navbar navbar-expand-lg">
                          <a className="navbar-brand" href="/">
                            <img src={JtcLogo} alt="JTC Logo" title="" />
                          </a>
                        </nav> */}
                      </div>
                    </div>
                  </div>
                </div>
                {navbar}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default GovernmentHeader;
